import { NavItemDef } from '../navItems';

export const AWB_NAV_ITEMS: NavItemDef[] = [
  {
    key: 'awb.divider.workbench',
    label: 'awb.navItems.accreditationWorkbench',
    divider: true,
  },
  {
    key: 'awb.accreditation-bodies',
    label: 'awb.navItems.accreditationBodies',
    subtitle: 'awb.navItems.accreditationVersionsSubtitle',
    path: 'accrediting-bodies',
    appPermissions: ['lexipolAccreditationManagerActions'],
    rootOnly: true,
  },
  {
    key: 'awb.accreditation-client',
    label: 'awb.navItems.accreditationBodies',
    subtitle: 'awb.navItems.accreditationClientSubtitle',
    href: '/admin/accreditation',
    permissions: ['listAccreditingBodies'],
    visibility: (ctx) => ctx.hasEnabledAccreditationVersion === true,
  },
  {
    key: 'awb.accreditation-rui',
    label: 'awb.navItems.accreditationVersions',
    subtitle: 'awb.navItems.accreditationVersionsSubtitle',
    href: '/admin/accreditation',
    appPermissions: ['lexipolAccreditationManagerActions'],
    featurePermission: 'awbRUIData',
  },
  {
    key: 'awb.accreditation-settings',
    label: 'awb.navItems.accreditationSettings',
    subtitle: 'awb.navItems.accreditationSettingsSubtitle',
    path: 'settings',
    permissions: ['acceptAccreditationBodyVersion'],
  },
];
